import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom"; // ✅ import useParams
import JsBarcode from "jsbarcode";

const PrintWorkTicketSticker = () => {
  const { caseId } = useParams(); // ✅ URL se case_id pick karega
  const [caseData, setCaseData] = useState(null);
  const barcodeRef = useRef(null);

  // Fetch case data according to caseId
  useEffect(() => {
    if (!caseId) return;

    fetch(`https://hms.backend.hiragroupcloud.com/api/cases/cases/${caseId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setCaseData(data); // ✅ Backend se jo case aaya usko set karo
        } else {
          console.error("Case not found");
        }
      })
      .catch((err) => console.error("API Error:", err));
  }, [caseId]);

  // Generate barcode and auto-print after caseData is loaded
  useEffect(() => {
    if (caseData && barcodeRef.current) {
      JsBarcode(barcodeRef.current, caseData.case_id, {
        format: "CODE128",
        displayValue: false,
        height: 40,
        width: 1.5,
        margin: 0,
      });

      // Auto print after barcode is rendered
      window.print();
    }
  }, [caseData]);

  if (!caseData) {
    return <div>Loading...</div>;
  }

  return (
      <div className="wrapper">
        {/* Buttons (hidden when printing) */}
        <div className="no-print button-group">
          <button onClick={() => window.print()}>Print Again</button>
          <button
              onClick={() => (window.location.href = `/case/${caseData.case_id}`)}
          >
            Back to Case #{caseData.case_id}
          </button>
        </div>

        {/* Label with case details */}
        <div className="label">
          <div style={{fontSize: '22px'}}>{caseData.provider_name}</div>
          <div style={{fontSize: '18px'}}>
  {caseData.case_id}
  { (caseData.first_name || caseData.last_name) && (
    <> ({[caseData.first_name, caseData.last_name].filter(Boolean).join(" ")})</>
  )}
</div>
          <div className="bold">
            {new Date(caseData.date).toLocaleDateString("en-GB")}
          </div>
          <svg ref={barcodeRef}></svg>
        </div>

        {/* Styles */}
        <style>{`
        * {
          box-sizing: border-box;
        }
        html, body, #root, .App, .wrapper {
          margin: 0 !important;
          padding: 0 !important;
          font-family: Arial, sans-serif;
          width: 100%;
          height: 100%;
        }
        .wrapper {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
        }
        .button-group {
          display: flex;
          gap: 8px;
          margin: 0 !important;
          padding: 0 !important;
        }
        .button-group button {
          background-color: #2b82d9;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 4px;
          font-size: 13px;
          cursor: pointer;
        }
        .button-group button:hover {
          background-color: #1f6bb8;
        }
        .label {
          width: 52.07mm;
          height: 38.1mm;
          border: 1px solid #ccc;
          padding: 1mm;
          font-size: 16px;
          margin: 0 !important;
        }
        .bold {
          font-weight: bold;
          font-size: 1.2em;
        }
        svg {
          height: 12mm;
          width: 100%;
          margin-left: -12%;
        }
        @media print {
          @page {
            size: 52.07mm 38.1mm;
            margin: 0;
          }
          body, html {
            margin: 0 !important;
            padding: 0 !important;
            width: 52.07mm;
            height: 38.1mm;
          }
          .no-print {
            display: none !important;
          }
          .label {
            margin: 0 !important;
            padding: 2mm;
            border: none;
            width: 52.07mm;
            height: 38.1mm;
            position: relative;
            transform: rotate(0deg); /* Ensure no rotation */
          }
          .wrapper {
            width: 52.07mm;
            height: 38.1mm;
            display: block;
          }
        }
      `}</style>

      </div>
  );
};

export default PrintWorkTicketSticker;
